import { render, staticRenderFns } from "./visitSet.vue?vue&type=template&id=28c7cfc0&"
import script from "./visitSet.vue?vue&type=script&lang=js&"
export * from "./visitSet.vue?vue&type=script&lang=js&"
import style0 from "./visitSet.vue?vue&type=style&index=0&id=28c7cfc0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports